import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ModalityTypeGroup } from "../../../../app.services/lookups/lookups.types/interfaces/modality.type.group";
import { LookupsService } from "../../../../app.services/lookups/services/lookups.service";
import { IThemeColor } from 'common/ui/components/button';


@Injectable({ providedIn: 'root' })
  export class ModalityTypeGroupService {
    private dataObserv:Observable<ModalityTypeGroup.ModalityTypeGroup[]>;
    readonly defaultBackgroundColor = 'transparent';
	readonly darkThemeBackgroundColor = '139,098,164';

    constructor(private lookupsService:LookupsService){
        let request=this.lookupsService.createRequestGetAllRecords(ModalityTypeGroup.lookupName);
        this.dataObserv =this.lookupsService.getLookup<ModalityTypeGroup.ModalityTypeGroup[]>(request).map(x=>x.lookupTable.data);
    }

	public getModalityTypeGroupColorByKey(modalityTypeKey:number):Observable<IThemeColor>{
		return this.getModalityTypeGroupColorByFilter(x=>x.modalityTypeGroupKey===modalityTypeKey);
	}
    public getModalityTypeGroupColor(modalityTypeCode:string):Observable<IThemeColor>{
        return this.getModalityTypeGroupColorByFilter(x=>x.code===modalityTypeCode);
    }

	private getModalityTypeGroupColorByFilter(filterFunc:(item:ModalityTypeGroup.ModalityTypeGroup) => boolean ):Observable<IThemeColor>{
		return this.dataObserv.pipe(map((x:ModalityTypeGroup.ModalityTypeGroup[]) =>
				x.filter(currModType=>filterFunc(currModType))),
			map((x:ModalityTypeGroup.ModalityTypeGroup[])=>x[0]?.color),
			map(x=>this.getThemeColor(x)));
	}

	private getThemeColor(colorString:string):IThemeColor{
		let color: IThemeColor;

		if (colorString) {
			// create the dark color that is used when the button is selected
			let darkColorString = colorString;
			try{
				let shade_factor = 0.2;
				let rgb = colorString.split(',');
				let rgb2 = rgb.map(x=>+x * (1 - shade_factor));
				darkColorString = rgb2.join(',');
			} catch {
				// nothing really, just use the light color for the dark one
			}

			color = {light: "rgb(" + colorString + ")", dark: "rgb(" + darkColorString + ")"};
		} else {
			color = {light: this.defaultBackgroundColor, dark: this.darkThemeBackgroundColor};
		}
		return color;
	}
}
